<template>
    <tr>
        <slot></slot>
    </tr>
</template>

<script setup>

</script>